/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import type { AxiosRequestConfig, AxiosResponse } from 'axios'
import { axiosInstance } from '../client'
import type {
	InvoicePaymentRenderPdfPathParams,
	InvoicePaymentRenderPdfResponse,
} from '../types/InvoicePaymentRenderPdf'

/**
 * GET /:organisation/invoices/:invoice/payments/:payment/pdf
 * @see backend/nexus/modules/Billing/Http/Controllers/InvoicePaymentController.php InvoicePaymentController::renderPdf
 */
export async function invoicePaymentRenderPdf(
	organisation: InvoicePaymentRenderPdfPathParams['organisation'],
	invoice: InvoicePaymentRenderPdfPathParams['invoice'],
	payment: InvoicePaymentRenderPdfPathParams['payment'],
	config?: AxiosRequestConfig,
): Promise<AxiosResponse<InvoicePaymentRenderPdfResponse>> {
	return axiosInstance.get(`/${organisation}/invoices/${invoice}/payments/${payment}/pdf`, config)
}
